import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import KsoftServiceInvoicesTable from "../../components/Tables/KsoftServiceInvoicesTable";

class ServiceInvoicesByStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
    };
  }

  getStatusConfig() {
    const { status } = this.props.match.params;

    const statusConfig = {
      draft: {
        title: "Taslak Faturalar",
        description: "Henüz gönderilmemiş taslak faturalar",
        icon: "icon-note",
        color: "primary"
      },
      running: {
        title: "Gönderilen Faturalar",
        description: "İşleme alınan faturalar",
        icon: "icon-clock",
        color: "warning"
      },
      done: {
        title: "Tamamlanmış Faturalar",
        description: "Başarıyla tamamlanmış faturalar",
        icon: "icon-check",
        color: "success"
      },
      cancel: {
        title: "İptal Edilmiş Faturalar",
        description: "İptal edilmiş veya reddedilmiş faturalar",
        icon: "icon-close",
        color: "danger"
      },
      error: {
        title: "Hatalı Faturalar",
        description: "İşlenirken hata oluşan faturalar",
        icon: "icon-exclamation",
        color: "danger"
      },
      unknown: {
        title: "Diğer Faturalar",
        description: "Durum bilgisi belirsiz faturalar",
        icon: "icon-question",
        color: "secondary"
      }
    };

    return statusConfig[status] || statusConfig.draft;
  }

  render() {
    const { status } = this.props.match.params;
    const config = this.getStatusConfig();

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText={config.title}
              Breadcrumb={[
                { name: "Faturalar", navigate: "" },
                { name: config.title, navigate: "" },
              ]}
            />

            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header">
                    <h2>
                      <i className={`${config.icon} text-${config.color}`}></i> {config.title}
                    </h2>
                    <small className="text-muted">{config.description}</small>
                  </div>
                  <div className="body">
                    <KsoftServiceInvoicesTable status={status} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(ServiceInvoicesByStatus)));

